import { FC } from 'react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { IDiagnosis, IPatient } from '../caremap/ICareMap';
import { CareMapState } from '../caremap/CareMapState';
import { MixPanelEventEmitter } from '../metrics/MixPanelEventEmitter';
import { DiagnosisDescriptor } from './DiagnosisDescriptor';
import { StructuredRecordList } from './structured-records/StructuredRecordList';

export type IDiagnosisList = {
    patient: IPatient;
    canAddEdit: boolean;
    diagnoses?: IDiagnosis[];
    onAdd: () => void;
    onClick: (id: string) => void;
};

export const DiagnosisList: FC<IDiagnosisList> = ({ patient, canAddEdit, diagnoses, onClick, onAdd }) => {
    const descriptor = useInstance(DiagnosisDescriptor);
    const mixpanel = useInstance(MixPanelEventEmitter);

    const careMapState = useInstance(CareMapState);
    useSubscription(() => careMapState);

    return (
        <StructuredRecordList
            descriptor={descriptor}
            records={diagnoses || []}
            canAddEdit={canAddEdit}
            isPublic={patient.diagnosesIsPublic ?? false}
            onTogglePublic={() => {
                const willBePublic = !patient.diagnosesIsPublic;
                mixpanel.track('Diagnosis Privacy Toggled', () => ({
                    'State': willBePublic ? 'public' : 'private'
                }));
                careMapState.updatePatient({ ...patient, diagnosesIsPublic: willBePublic });
            }}
            onRowClick={onClick}
            onAdd={onAdd}
        />
    );
};
